import { useState } from "react";
import Button from "../../../../components/Button";
import Modal from "../../../../components/modals/Modal";
import { bracketTypes, bracketTypeLabels, bracketSizes } from "../constants";
import { useTournament, useTournamentUpdate } from "../../TournamentContext";
import createBracket from "../../../../functions/generateBracket/createBracket";
import { doc, updateDoc, writeBatch } from "firebase/firestore";
import { firestore } from "../../../../firebase/config";
import bracketRunThrough from "../../../../functions/generateBracket/bracketRunThrough";
import calculateTeamStats from "../../../../functions/calculateTeamStats";
import sortGroups from "../../../../functions/sortGroups";

const CreateBracket = ({ tournamentId }) => {
  const { tournament, teams, matches } = useTournament();
  const { groups, headToHead, schedule } = tournament;
  const { updateGames } = useTournamentUpdate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bracketType, setBracketType] = useState("single");
  const [numberOfTeams, setNumberOfTeams] = useState(Object.keys(teams).length);
  const [numberOfUpperTeams, setNumberOfUpperTeams] = useState(4);
  const [isRandom, setIsRandom] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const writeBracket = async () => {
    const teamStats = calculateTeamStats(
      matches,
      teams,
      tournament?.pointsPerWin
    );

    const sortedGroups = sortGroups(
      groups,
      schedule,
      matches,
      teamStats,
      headToHead
    );

    const { bracket, games } = createBracket(
      sortedGroups,
      bracketType,
      numberOfTeams,
      numberOfUpperTeams,
      isRandom,
      teamStats
    );

    const tournamentRef = doc(firestore, "tournaments", tournamentId);
    const bracketRef = doc(firestore, "brackets", tournamentId);

    const firestoreUpdates = bracketRunThrough(bracket, games, updateGames);

    const creatBracketBatch = writeBatch(firestore);

    creatBracketBatch.update(tournamentRef, {
      bracket: bracket,
      bracketType: bracketType,
      bracketTimes: {
        startTimes: ["09:00"],
        gameLength: tournament.scheduleTimes.gameLength,
        interval: tournament.scheduleTimes.interval,
        numberOfCourts: tournament.scheduleTimes.numberOfCourts,
      },
    });

    creatBracketBatch.set(bracketRef, games);

    try {
      await creatBracketBatch.commit();
      await updateDoc(bracketRef, firestoreUpdates);
      window.location.reload();
    } catch (error) {
      alert(error.message);
      console.log(error);
    }
  };

  return (
    <div className="flex justify-center">
      <Button
        color="indigo"
        dataTestId="create-bracket-button"
        onClick={toggleModal}
      >
        Create Bracket
      </Button>

      <Modal
        isOpen={isModalOpen}
        title={"Create Bracket"}
        subtitle={"Generate bracket based off selections"}
        onCancel={toggleModal}
        onConfirm={writeBracket}
      >
        <div className="flex flex-wrap gap-2 my-2">
          {bracketTypes.map((type) => {
            if (
              Object.keys(teams).length < 6 &&
              (bracketType === "singleHayes" || bracketType === "doubleHayes")
            ) {
              return null;
            }

            return (
              <button
                key={type}
                data-testid={`${bracketType}-bracket-button`}
                type="button"
                onClick={() => setBracketType(type)}
                className={`px-4 py-2 border rounded-lg text-sm font-medium
                  ${
                    bracketType === type
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300 hover:bg-gray-300"
                  }
                `}
              >
                {bracketTypeLabels[type]}
              </button>
            );
          })}
        </div>

        <div className="flex my-2">
          <p>Number of Teams in Bracket: </p>
          <select
            defaultValue={numberOfTeams}
            onChange={(event) => setNumberOfTeams(event.target.value)}
          >
            {Object.keys(teams).map((team, index) => {
              const number = index + 1;

              if (number < 4) {
                return null;
              }

              if (
                (bracketType === "singleHayes" ||
                  bracketType === "doubleHayes") &&
                number < 6
              ) {
                return null;
              }

              return (
                <option key={index} value={number}>
                  {number}
                </option>
              );
            })}
          </select>
        </div>

        {(bracketType === "singleHayes" || bracketType === "doubleHayes") && (
          <div className="flex my-2">
            <p>Upper Bracket Size: </p>
            <select
              onChange={(event) => setNumberOfUpperTeams(event.target.value)}
              type="dropdown"
              defaultValue={numberOfUpperTeams}
            >
              {bracketSizes.map((size) => {
                if (size >= numberOfTeams) {
                  return null;
                }
                return (
                  <option key={size} value={size}>
                    {size}
                  </option>
                );
              })}
            </select>
          </div>
        )}

        <label
          htmlFor={"randomize-same-ranked-teams"}
          className="flex items-center mt-4 space-x-2 cursor-pointer"
        >
          <input
            type="checkbox"
            id={"randomize-same-ranked-teams"}
            checked={isRandom}
            onChange={() => setIsRandom(!isRandom)}
            className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer"
          />
          <span className="text-gray-700">
            {"Randomize order of same ranked teams"}
          </span>
        </label>
      </Modal>
    </div>
  );
};

export default CreateBracket;
